import { configureRequestParams, getErrorMessage } from '../utils/helpers'

import axios from './instance'

/**
 * Gets the certificates for an entity
 * @param {string} entity - The entity id to get certificates for.
 * @param {import('../utils/helpers').RequestParams} params - The request parameters including sorting, pagination, searchTerm
 * */
export const getEntityCertificates = async (
  entity,
  { sorting, pagination, searchTerm, filters },
) => {
  const params = configureRequestParams(sorting, pagination, searchTerm, filters)
  try {
    return await axios.get(
      `/entities/${entity}/certificates/${params}&expand=course_requirements.primary_course,course_requirements.alternative_courses`,
    )
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Gets all certificates for an entity, useful for filtering
 * @param {string} entityId - The entity id to get certificates for.
 * */
export const getAllEntityCertificates = async (entityId) => {
  try {
    return await axios.get(`/entities/${entityId}/certificates/?limit&fields=name,id`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
